import { Label as e } from "../../Typography/Typography.mjs";
import { EventAnimation as t } from "../EventAnimation/EventAnimation.mjs";
import { useSegmentThumb as n } from "./hooks/useSegmentThumb.mjs";
import { Segment as r, SegmentIcon as i, Thumb as a, Track as o } from "./SegmentedTabs.styled.mjs";
import { useCallback as s, useMemo as c, useRef as l, useState as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
//#region src/components/SegmentedTabs/SegmentedTabs.tsx
var p = ({ options: p, value: m, onChange: h, variant: g = "capsule", "aria-label": _, className: v }) => {
	let y = l(null), b = l(null), x = n(y, b, c(() => `${m}|${p.map((e) => e.value).join(",")}`, [p, m])), S = g === "underline" ? 28 : 20, [C, w] = u(null), T = s((e) => {
		e !== m && (w((t) => ({
			value: e,
			key: (t?.key ?? 0) + 1
		})), h(e));
	}, [h, m]), E = (e) => {
		let t = p.findIndex((e) => e.value === m);
		if (t === -1) return;
		let n = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
		if (!n) return;
		e.preventDefault();
		let r = p[(t + n + p.length) % p.length];
		T(r.value);
	};
	return /* @__PURE__ */ f(o, {
		ref: y,
		role: "tablist",
		"aria-label": _,
		className: v,
		$variant: g,
		onKeyDown: E,
		children: [/* @__PURE__ */ d(a, {
			$ready: x !== null,
			$variant: g,
			style: x ? {
				transform: `translateX(${x.x}px)`,
				width: x.width
			} : void 0
		}), p.map((n) => {
			let a = n.value === m;
			return /* @__PURE__ */ f(r, {
				ref: a ? b : void 0,
				type: "button",
				role: "tab",
				"aria-selected": a,
				tabIndex: a ? 0 : -1,
				$variant: g,
				$selected: a,
				onClick: () => T(n.value),
				children: [n.icon && /* @__PURE__ */ d(i, {
					"aria-hidden": !0,
					$size: S,
					children: /* @__PURE__ */ d(t, {
						name: n.icon,
						width: S,
						color: "currentColor",
						motion: a,
						playKey: C?.value === n.value ? C.key : void 0
					})
				}), /* @__PURE__ */ d(e, {
					weight: a ? "semibold" : "medium",
					color: "inherit",
					children: n.label
				})]
			}, n.value);
		})]
	});
};
//#endregion
export { p as SegmentedTabs };
